import { useEffect, useRef } from 'react';
import { db } from '../utils/db';

const GPU_WAKE_S = 40;
const RENDER_S = 25;

/**
 * Live simulation of the agents, shared by every Anna screen: streams scripted events
 * into each thread at the speed of its task, wakes the GPU-brein (~40 s) and drives the Studio render.
 */
export function useAgentSim(epoch: number, paused: boolean, onRenderDone: () => void) {
  const doneRef = useRef(onRenderDone);
  doneRef.current = onRenderDone;
  const tick = useRef(0);

  useEffect(() => {
    tick.current = 0;
  }, [epoch]);

  useEffect(() => {
    if (paused) return;
    const id = window.setInterval(() => {
      const t = ++tick.current;
      const state = db.getState();

      state.agentTasks.forEach((task) => {
        if (task.status !== 'bezig' || !task.upcoming?.length) return;
        const every = Math.max(5, Math.round(7 / Math.max(0.1, task.pace)));
        if (t % every === 0) db.advanceTask(task.id);
      });

      const render = state.renders[0];
      const studio = state.agentTasks.find((x) => x.agent === 'studio');
      if (render?.status === 'bezig' && studio && studio.status === 'bezig') {
        if (t < GPU_WAKE_S) {
          if (t % 5 === 0) db.updateTask(studio.id, { stepLabel: `GPU-brein wordt gewekt (~${GPU_WAKE_S - t} s)` });
        } else if (t === GPU_WAKE_S) {
          db.setGpu('actief');
          db.updateTask(studio.id, { step: 2, stepLabel: 'render 0%', events: [...studio.events, 'GPU-brein actief'] });
        } else {
          const pct = Math.min(100, Math.round(((t - GPU_WAKE_S) / RENDER_S) * 100));
          if (pct >= 100) doneRef.current();
          else if (t % 2 === 0) db.updateTask(studio.id, { step: pct > 50 ? 3 : 2, stepLabel: `render ${pct}%` });
        }
      }

      if (t % 10 === 0 && state.agentTasks.some((x) => x.status === 'bezig' && x.where === 'cloud')) db.addCloudCost(0.01);
    }, 1000);
    return () => window.clearInterval(id);
  }, [paused, epoch]);
}
